import { config } from '../config';
import { contractsResponseSchema, type Contract } from '../features/api/contracts/productActivationBackendCodec';
import { type ApiError, baseApi } from './baseApi';

type MarketplaceApiError = {
    status: number | string;
    message: string;
};

const errorMessageForStatus = (status: number | string): string => {
    if (status === 401) {
        return 'UNAUTHENTICATED';
    }
    if (status === 403) {
        return 'ACCESS_DENIED';
    }
    if (status === 404) {
        return 'NOT_FOUND';
    }
    return 'Backend error';
};

const transformMarketplaceError = (response: ApiError): MarketplaceApiError => ({
    status: response.status,
    message: errorMessageForStatus(response.status),
});

export const marketplaceApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getContracts: builder.query<Contract[], { accountId: string; assetIds: string[] }>({
            query: ({ accountId, assetIds }) => ({
                url: `${config.backend.MARKETPLACE_BACKEND}/admin/${encodeURIComponent(accountId)}/contracts`,
                params: {
                    resource_ids: assetIds.join(','),
                    exclude_periods: 'p1d',
                },
            }),
            transformResponse: response => contractsResponseSchema.parse(response).contracts,
            transformErrorResponse: transformMarketplaceError,
            providesTags: (_result, _error, { accountId }) => [{ type: 'Contract', id: accountId }],
        }),
    }),
});

export const { useLazyGetContractsQuery } = marketplaceApi;
